<mat-card *ngIf="entity" [ngStyle]="_card_style" (mouseover)="cardMouseEvent($event)"
  (mouseout)="cardMouseEvent($event)" (click)="onSelect.emit(entity)" [ngClass]="_card_classes">
  <mat-card-content>
    <mat-icon *ngIf="showDeleteButton" class="remove-icon" (click)="remove(entity, $event)">clear</mat-icon>

    <div class="entity-picture">
      <app-image-view [src]="entity.relation?.photo_url ? entity.relation.photo_url : entity.photo_url"
        [imageSize]="iSize" [radius]="radius" [ngStyle]="getImageStyle()">
      </app-image-view>
    </div>
    <div class="entity-info" [ngClass]="getEntityStatusClass()">
      <div *ngIf="showName" class='entity-name'>

        {{getName()}}

        <i *ngIf="showVerificationBadge && entity.validated"
        matTooltip="Perfil verificado."
        color="primary" class="fa fa-check"></i>

        <i *ngIf="showSelfUserBadge && !entity.self_user" matTooltip="Perfil sem um usuário vinculado."
        class="fa fa-user-slash red">
        </i>
      </div>
      <div *ngIf="showNickname" class='entity-nickname'>

        {{getNickname()}}

        <i *ngIf="showVerificationBadge && entity.validated && !showName"
        matTooltip="Perfil verificado."
        color="primary" class="fa fa-check"></i>

        <i *ngIf="showSelfUserBadge && !entity.self_user && !showName" matTooltip="Perfil sem um usuário vinculado."
        class="fa fa-user-slash red">
        </i>


      </div>
      <div class='entity-type' *ngIf="showType==true">{{getEntityType()}}</div>
      <ng-content select="[entity-content]"></ng-content>

    </div>

  </mat-card-content>

</mat-card>
